import { render } from "./DeleteProductConfirm.vue?vue&type=template&id=b2dc46dc&scoped=true"
import script from "./DeleteProductConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteProductConfirm.vue?vue&type=script&lang=js"

import "./DeleteProductConfirm.vue?vue&type=style&index=0&id=b2dc46dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2dc46dc"]])

export default __exports__